// Resuelve el copy de una violación contra el schema. Prefiere `summaryLabel`
// (descriptivo, post-sesión); si la regla no lo tiene, cae a `feedback`
// (imperativo durante-ejercicio); último fallback es el id raw.
//
// Compartido entre SesionCamara (al cierre construye topAMejorar para route
// state) y useResumenSesion (al fetch reconstruye topAMejorar desde el jsonb
// persistido). Mismo mapeo en ambos para que el copy del summary sea
// consistente entre el flow normal y el de refresh-safe.

import type { ExerciseSchema } from "./types";

export function getViolationLabel(
  violationId: string,
  schema: ExerciseSchema,
): string {
  const rule = schema.rules.find((r) => r.violationId === violationId);
  if (!rule) return violationId;
  return rule.summaryLabel ?? rule.feedback;
}
